// 用户取，只有一个箱格
<template>
  <div class="mailOpenBoxOne back-index">
    <!-- 流程 -->
    <userFetchFlow></userFetchFlow>
    <div class="container" v-loading="isLoading">

      <span class="status" v-if="box.status" :class="[box.error ? 'success' : 'fail']"></span>

      <p class="info" v-if="box.status" v-text="box.error ? box.number + '号箱格已打开' : box.message"></p>

      <p class="des" v-if="box.error">请取出物品并随手关门</p>

    </div>

    <!-- 倒计时10秒 -->
    <countDown :time="10" v-if="!isLoading"></countDown>
  </div>
</template>

<script>
// 组件
import userFetchFlow from './userFetchFlow'
import countDown from '../common/countDown'

// js
import {
  pickup,
  showToast,
} from '../../../../static/mailBox/js/request.js'
import { storage, messageError } from '../../../../static/js/utils/utility.js'

export default {
  name: 'openBoxOne',

  components: {
    countDown,
    userFetchFlow,
  },

  data () {
    return {
      box: {
        number: '',
        error: false,
        status: false,
      },
      isLoading: true,
    }
  },

  created () {
    // this.$store.state.mail_index = 2
    this.$store.commit('mail_index', 2)
    this.pickup()
  },

  mounted () {
  },

  methods: {
    
    pickup: async function() {
      let vm = this
      vm.isLoading = true
      let data = {'device_no_id': storage.localGetItem('device_no_id')}
      let res = await pickup(data)
      console.log('取件返回的数据：', res)
      if (res.meta.code === 200) {
        vm.box.status = true
        vm.box.error = true
        // vm.box.message = res.data.message
        vm.box.number = res.data.box_number
      } else {
        vm.box.error = false
        vm.box.status = true
        vm.box.message = res.meta.message
        // showToast(res.meta.message)
      }
      vm.isLoading = false
    }
  }
}
</script>
<style lang="less">
.mailOpenBoxOne {
  .container {
    .el-loading-mask {
      background-color: transparent;
    }
  }
}
</style>

<style lang="less" scoped>
.mailOpenBoxOne {
  width: 100%;
  text-align: center;
  .container {
    height: 5rem;
    .status {
      display: block;
      width: 2rem;
      height: 2rem;
      margin: 0.8rem auto 0;
    }
    .status.success {
      background: url(../../../../static/mailBox/images/icon/success.png) center no-repeat;
      background-size: 100%;
    }
    .status.fail {
      background: url(../../../../static/mailBox/images/icon/fail.png) center no-repeat;
      background-size: 100%;
    }
    .info {
      font-size: 0.45rem;
      line-height: 50px;
      margin-top: 35px;
    }
    .num {
      font-weight: bold;
    }
    .des {
      font-size: 0.3rem;
      line-height: 40px;
    }

  }
  .hint {
    font-size: 15px;
    color: #ff0000;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .save-again {
    width: 220px;
    height: 45px;
    color: #ffffff;
    margin: 20px auto 0;
    line-height: 45px;
    border-radius: 5px;
    background-color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/userFetch/openBoxOne.vue